import { projectVenueDatesSlice } from '../project-venue-dates.slice';

export const clearProjectVenueDates = projectVenueDatesSlice.actions.clearItems;
